import React from 'react';
import { Box, styled, keyframes } from '@mui/material';
import videoFile from '../../Assets/Videos/video2.mp4';
import { useIsOnMobile } from '../../hooks/layoutHooks';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const VideoSection = styled(Box)(({ theme }) => ({
  animation: `${fadeIn} 0.6s ease-out`,
  [theme.breakpoints.down('md')]: {
    padding: 0,
  },
}));

const VideoContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: '0 12px 32px -8px rgba(0, 0, 0, 0.25)',
  background: '#000',
  [theme.breakpoints.down('md')]: {
    borderRadius: 0,
    maxWidth: '100%',
    boxShadow: 'none',
  },
}));

const VideoWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: '#000',
  '& video': {
    display: 'block',
    width: '100%',
  },
}));

export const IntroVideoBlock = () => {
  const isMobile = useIsOnMobile();
  
  return (
    <VideoSection>
      <VideoContainer>
        <VideoWrapper>
          <video
            width="100%"
            controls
            preload="metadata"
            style={{ 
              height: isMobile ? '280px' : '580px',
              objectFit: 'cover',
              display: 'block',
            }}
          >
            <source src={videoFile} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </VideoWrapper>
      </VideoContainer>
      
    </VideoSection>
  );
};
